// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MessageRepo_DownloadChatMediaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /message_repo/downloadChatMedia
 *
 * Returns the result of downloading chat media from the external messaging repository.
 * Data is proxied from external msgRepoApi service.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface MessageRepo_DownloadChatMediaResponseDados {
success: boolean
downloaded_count: number
total_count: number
files: string[]
}

export type MessageRepo_DownloadChatMediaResponse = ApiResponse<MessageRepo_DownloadChatMediaResponseDados>;

registerResponseContract('MessageRepo_DownloadChatMediaResponse', {
  success:          { type: 'boolean', required: true },
  downloaded_count: { type: 'number',  required: true },
  total_count:      { type: 'number',  required: true },
  files:            { type: 'array',   required: true },
})
